import React, {useEffect, useState} from 'react';
import Check from "../../Assets/check.svg";
import RightSidebar from "../../Container/RightSidebar";
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";

import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';

// -- redux
import {connect} from "react-redux";
import {GetProduct, UpdateProductStatus, UpdateProductOrderStatus} from "../../Redux/Actions/ProductAction"

function Product(props) {

    const [Open, SetOpen] = useState(false);
    const [Delete, SetDelete] = useState(false);
    const [Data, SetData] = useState('');
    const [update, SetUpdate] = useState(false);
    const [InitialArray, setInitialArray] = useState([]);
    const [CardsArray, setCardsArray] = useState([]);
    const [OpenModal, setModal] = useState(false);
    const [ProductId, setProductId] = useState(false);
    const [Name, setName] = useState(false);


    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(CardsArray);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setCardsArray(items);
        passData(items)
    };

    const passData = (items) => {
        let data = [];
        items.map((arr) =>{
            let index = items.findIndex(x => x.title === arr.title);
            let id = items.filter(x => x.id === arr.id);
            data.push(
                {
                    id: id[0].id,
                    order_number: index + 1
                }
            )
        });
        props.UpdateProductOrderStatus(data);
    };

    const handleEdit = (e, data) => {
        e.preventDefault();
        SetData(data);
        SetOpen(true)
    };

    useEffect(() => {
        let FilteredArray = '';
        if(props.userData.length > 0 && (props.status.length === 0 || props.status.length === 2)){
            let data=[];
            props.userData.forEach(element => {
                FilteredArray = InitialArray.filter(
                    (post) => post.user_type.includes(',') ? (post.user_type.split(",")).includes(element) : post.user_type === element
                );
                data.push(...FilteredArray)
    
            });
            const uniqueIds = [];
            const unique = data.filter(element => {
                const isDuplicate = uniqueIds.includes(element.id);
        
                if (!isDuplicate) {
                  uniqueIds.push(element.id);
        
                  return true;
                }
        
                return false;
              });
              
            
              setCardsArray(unique);
        }
        else if(props.status.length > 0 && props.userData.length === 0){
            if(props.status.toString() === '0'){
                FilteredArray = InitialArray.filter(post => post.status === 0);
                setCardsArray(FilteredArray)
            } else if(props.status.toString() === '1'){
                FilteredArray = InitialArray.filter(post => post.status === 1);
                setCardsArray(FilteredArray)
            } else if((props.status.toString() !== '0' || props.status.toString() !== '1') && props.status.length > 0){
                setCardsArray(InitialArray)
            }
        } else{
            if(props.status.length === 1){
                let data=[]
                props.userData.forEach(element => {
                  FilteredArray = InitialArray.filter(
                    (post) => ((post.user_type.includes(',') ? (post.user_type.split(",")).includes(element) : post.user_type === element) && post.status === parseInt(props.status))
                  );
                  data.push(...FilteredArray);
              });
              
              const uniqueIds = [];
        
              const unique = data.filter(element => {
                const isDuplicate = uniqueIds.includes(element.id);
        
                if (!isDuplicate) {
                  uniqueIds.push(element.id);
        
                  return true;
                }
        
                return false;
              });
              
              setCardsArray(unique);
            // if(props.status.toString() === '0' && props.userData.toString() === '3'){
            //     FilteredArray = InitialArray.filter(post => post.status === 0 && post.user_type === 3);
            //     setCardsArray(FilteredArray)
            // } else if(props.status.toString() === '1' && props.userData.toString() === '3'){
            //     FilteredArray = InitialArray.filter(post => post.status === 1 && post.user_type === 3);
            //     setCardsArray(FilteredArray)
            // } else if(props.status.toString() === '0' && props.userData.toString() === '2'){
            //     FilteredArray = InitialArray.filter(post => post.status === 0 && post.user_type === 2);
            //     setCardsArray(FilteredArray)
            // } else if(props.status.toString() === '1' && props.userData.toString() === '2'){
            //     FilteredArray = InitialArray.filter(post => post.status === 1 && post.user_type === 2);
            //     setCardsArray(FilteredArray)
            // } else if((props.status.toString() !== '0' || props.status.toString() !== '1') && props.userData.toString() === '3'){
            //     FilteredArray = InitialArray.filter(post => post.user_type === 3);
            //     setCardsArray(FilteredArray)
            // } else if((props.status.toString() !== '0' || props.status.toString() !== '1') && props.userData.toString() === '2'){
            //     FilteredArray = InitialArray.filter(post => post.user_type === 2);
            //     setCardsArray(FilteredArray)
            // } else if((props.userData.toString() !== '0' || props.userData.toString() !== '1') && props.status.toString() === '0'){
            //     FilteredArray = InitialArray.filter(post => post.status === 0);
            //     setCardsArray(FilteredArray)
            // } else if((props.userData.toString() !== '0' || props.userData.toString() !== '1') && props.status.toString() === '1'){
            //     FilteredArray = InitialArray.filter(post => post.status === 1);
            //     setCardsArray(FilteredArray)
            } else{
                setCardsArray(InitialArray)
            }
        }
    }, [props.userData, props.status]);

    useEffect(() => {
        const data = {
            user_type: '',
            status: ''
        };
        props.GetProduct(data);
    }, [props.status_data, props.add_data, props.edit_data, props.delete_data, props.add, update]);

    useEffect(()=> {
        if(props.data && props.data.data && props.data.data.data) {
            props.enabled(props.data.data.enabled);
            props.disabled(props.data.data.disabled);
            setInitialArray(props.data.data.data);
            props.clear('');
        }
    },[props.data, props.status_data, props.edit_data]);

    useEffect(() => {
        props.clear('clear');
    },[]);

    useEffect(() => {
        if(props.data && props.data.data && props.data.data.data){
            setCardsArray(InitialArray);
        }
    }, [InitialArray, props.status_data, props.edit_data]);

    useEffect(() => {
        if(!props.Search){
            setCardsArray(InitialArray);
        }
        if(props.Search.length > 2){
            const FilteredArray = InitialArray.filter((post) => {
                const postName = post.title;
                return postName.toLowerCase().includes(props.Search.toLowerCase());
            });
            setCardsArray(FilteredArray)
        }
    }, [props.Search]);

   

    const handleModal = (e, type,name, id) => {
        e.preventDefault();
        setModal(type);
        setName(name);
        setProductId(id)
    };

    const CloseModal = (e, type) => {
        e.preventDefault();
        let data;
        if(type === 'enable_yes'){
            data = {
                id: ProductId,
                status: 0
            };
            props.UpdateProductStatus(data);
            setTimeout(function () {
                SetUpdate(!update);
            }, 1000)
        } else{
            setModal(!OpenModal)
        }

        if(type === 'disable_yes'){
            data = {
                id: ProductId,
                status: 1
            };
            props.UpdateProductStatus(data);
            setTimeout(function () {
                SetUpdate(!update);
            }, 1000)
        } else{
            setModal(!OpenModal)
        }
    };

    return (
        <>
            {props.loading && <Loader/>}
            {CardsArray.length > 0 ? <div className="box-wrap ml-4 mr-4">
                <DragDropContext onDragEnd={handleOnDragEnd}>
                    {CardsArray.map((item, index) => {
                        let customer_data=item.user_type.split(',');
                        return <Droppable key={index} className="box-grid m-4" droppableId={item.id.toString()} type="listing">
                            {(provided) => (
                                <div {...provided.droppableProps} ref={provided.innerRef}>

                                    <Draggable key={item.id} draggableId={(item.id).toString()} index={index}>
                                            {(provided) => (
                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                    className='box-content light-grey-background h-100'>
                                                    <div className="box h-100 position-relative">
                                                        <div>
                                                            <div
                                                                className="box-header dark-background h-auto d-flex align-items-start flex-column p-3">
                                                                <h6 style={{fontSize:'24px'}} className="text-white col-12 text-truncate pl-0 box-title f-18 mb-1 ">
                                                                    {item.title}
                                                                </h6>
                                                                <div className="form-button-ghost">
                                                                    APR {item.apr} % | APY {item.apy} %
                                                                </div>
                                                                <ul className='p-0 mt-3'>
                                                                {item.description && item.description.split('\n').map((point, index) => (
                                                                    <li key={index}>
                                                                        <span
                                                                            style={{wordBreak: 'break-word'}}
                                                                            className="box-points ml-2 text-light-grey f-14">{point}</span>
                                                                    </li>))}
                                                                </ul>
                                                                <div className='d-flex align-items-center'>
                                                                    <h2 className="text-green m-0">{item.est_minutes}</h2>
                                                                    <span style={{fontSize:'18px', lineHeight: '15px'}} className="text-light-grey ml-2 w-75 f-18">Est. minutes to open</span>
                                                                </div>
                                                            </div>
                                                            <div className="box-content light-grey-background p-3">
                                                                <div className="d-flex justify-content-between mb-3">
                                                                    <div className="type">
                                                                        <label className="box-type-para text-grey-6 f-14 m-0">
                                                                            Type
                                                                        </label>
                                                                        <p className="text-white f-16 m-0">
                                                                            {item.type === 1 && 'Tab'}
                                                                            {item.type === 2 && 'App'}
                                                                            {item.type === 3 && 'Service'}
                                                                            {item.type === 4 && 'WebView'}
                                                                        </p>
                                                                    </div>
                                                                    <div className="user-type mr-5">
                                                                        <label className="box-type-para text-grey-6 f-14 m-0">
                                                                            User Type
                                                                        </label>
                                                                        <div className="text-white f-16 m-0">
                                                                            { customer_data.map((value) => {
                                                                                return (
                                                                                <>
                                                                                    <div>{value == '2' && "Personal Banking "}</div>
                                                                                    <div>{value == '3' && "Business "}</div>
                                                                                    <div>{value == '5' && "V1be User "}</div>
                                                                                </>
                                                                                )
                                                                            })}
                                                                            
                                                                            </div>
                                                                    </div>
                                                                </div>
                                                                {item.type !== 2 && <div className="text-white pb-5 mb-5">
                                                                    <label className="box-type-para text-grey-6 f-14 m-0">
                                                                        Information
                                                                    </label>
                                                                    <p className='f-16 m-0 information pb-1'>
                                                                        {item.information === '21' && 'Primis Banking'}
                                                                        {item.information === '1' && 'Home'}
                                                                        {item.information === '2' && 'Products'}
                                                                        {item.information === '3' && 'Services'}
                                                                        {item.information === '4' && 'Social'}
                                                                        {item.information === '5' && 'Help'}
                                                                        {item.information === '11' && 'Change Name'}
                                                                        {item.type === 4 && item.information}
                                                                    </p>
                                                                </div>}
                                                                {item.type === 2 && <>
                                                                    <div className="text-white pt-3 pb-5 mb-5 pl-0">
                                                                        <label className="box-type-para text-grey-6 f-14 m-0">
                                                                            Android Url
                                                                        </label>
                                                                        <p className='f-16 m-0 information pb-1'>
                                                                            {item.app_android_url}
                                                                        </p>
                                                                        <label className="box-type-para text-grey-6 f-14 m-0">
                                                                            IOS Url
                                                                        </label>
                                                                        <p className='f-16 m-0 information pb-1'>
                                                                            {item.app_ios_url}
                                                                        </p>
                                                                    </div>
                                                                </>}
                                                                <div
                                                                    className='box-footer d-flex justify-content-between align-items-end'
                                                                    style={{position: 'absolute', width: '90%', bottom: '15px'}}
                                                                >
                                                                    <div>
                                                                        <p
                                                                            className={item.status ?
                                                                                "text-green label-para f-12" :
                                                                                "text-grey label-para f-12"
                                                                            }
                                                                        >
                                                                            {item.status ? 'Enabled' : 'Disabled'}
                                                                        </p>
                                                                        <label className="switch mb-0">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={item.status}
                                                                                readOnly
                                                                            />
                                                                            <span className="slider round"
                                                                                  onClick={(e) => handleModal(e, item.status === 1 ? 'enable' : 'disable', item.title, item.id)}/>
                                                                        </label>
                                                                    </div>
                                                                    <button
                                                                        onClick={(e) => handleEdit(e, item)}
                                                                        className="green-background edit-button f-14"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                </div>
                            )}
                        </Droppable> })
                    }
                    </DragDropContext>
                </div> :
                    <div className='d-flex text-center justify-content-center'>
                        <p className='m-0 text-white'>Nothing found</p>
                    </div>
            }
            <RightSidebar
                Type='Edit'
                data={Data}
                sidebar={Open}
                delete={() => SetDelete(!Delete)}
                close={() =>  SetOpen(false)}
                response={(e) => (e)}
            />
            { OpenModal && <Modal Name={Name} Type={OpenModal} Close={(e, type) => CloseModal(e, type)}/> }
        </>
    );
}

const mapStateToProps = ({ProductReducer}) => {
    const {loading, data, status_data, add_data, edit_data, delete_data, order_status_data} = ProductReducer;
    return {loading, data, status_data, add_data, edit_data, delete_data, order_status_data}
};

const mapDispatchToProps = {
    GetProduct,
    UpdateProductStatus,
    UpdateProductOrderStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);